var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "city",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: currentColor;\n        stroke: none;\n        stroke-width: 1px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 4.1,
    y: 14.40353,
    width: 3,
    height: 11.19652
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.70001,4.40002v21.20001h5.17908v-8.94653h2.49634V4.40002s-7.67542,0-7.67542,0ZM10.54834,23.98944h-1.336v-1.33594h1.336v1.33594ZM10.54834,21.23944h-1.336v-1.33594h1.336v1.33594ZM10.54834,18.48944h-1.336v-1.33594h1.336v1.33594ZM10.54834,15.73944h-1.336v-1.33594h1.336v1.33594ZM10.54834,12.98944h-1.336v-1.33594h1.336v1.33594ZM10.54834,10.23944h-1.336v-1.33594h1.336v1.33594ZM10.54834,7.48944h-1.336v-1.33594h1.336v1.33594ZM13.91553,15.73944h-1.33594v-1.33594h1.33594v1.33594ZM13.91553,12.98944h-1.33594v-1.33594h1.33594v1.33594ZM13.91553,10.23944h-1.33594v-1.33594h1.33594v1.33594ZM13.91553,7.48944h-1.33594v-1.33594h1.33594v1.33594Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.43109,17.4035v8.19647h7.35944v-8.19647h-7.35944ZM16.09521,23.98944h-1.33594v-1.33594h1.33594v1.33594ZM19.4624,23.98944h-1.33594v-1.33594h1.33594v1.33594Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.20001,11.40002v5.25348h2.2016v8.94647h4.49841v-14.19995h-6.70001ZM21.53442,14.32538h-1.33594v-1.33594h1.33594v1.33594ZM24.90155,14.32538h-1.33594v-1.33594h1.33594v1.33594Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityIcon);
export default __webpack_public_path__ + "static/media/CityIcon.d435089c99993e4121725ac51b6b6934.svg";
export { ForwardRef as ReactComponent };